module.exports = __webpack_public_path__ + "img/notice.1e40a671.svg";